module.exports = __webpack_public_path__ + "img/index-spot.f021b4b0.png";